export const ADAPTIVE_SERVICE_FACILITIES = 305
export const ECO_CENTER = 530
